import * as React from 'react';

function SvgComponent(props) {
  return (
    <svg
      width={206}
      height={141}
      viewBox='0 0 206 141'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <g clipPath='url(#clip0_118_1957)'>
        <path
          opacity={0.18}
          d='M183.508 28.394c1.965 11.15-9.266 22.144-5.796 32.913 1.997 6.22 7.988 10.099 13.153 14.1 8.208 6.344 15.781 15.563 14.648 25.853-1.226 11.1-11.83 18.947-22.369 22.731C143.611 138.174 8.23 163.087.214 100.2c-1.527-12.02 5.4-23.93 13.173-33.246 6.184-7.406 40.624-40.697 53.213-46.912 56.075-27.695 111.122-24.466 116.908 8.352z'
          fill='#00D563'
        />
        <path
          opacity={0.05}
          d='M114.817 12.299s74.138-.645 61.702 29.583c-9.633 23.388 1.375 25.102 4.817 36.413 3.443 11.311-.554 24.197-8.856 30.303-8.303 6.105-41.47 5.026-41.47 14.075s-9.236 5.74-9.236 5.74H63.636l10.62-31.918L114.816 12.3z'
          fill='#000405'
        />
        <path
          d='M126.045 124.867H63.636v3.546h62.409v-3.546zM116.512 96.493H74.256v28.374h42.256V96.493z'
          fill='#00D563'
        />
        <path d='M116.512 96.493H74.256v28.374h42.256V96.493z' fill='#00D563' />
        <path
          d='M116.512 96.493H74.256v28.374h42.256V96.493z'
          fill='url(#paint0_linear_118_1957)'
        />
        <path
          d='M172.48 16.217v74.31c0 2.13-.421 4.24-1.24 6.207a16.21 16.21 0 01-3.53 5.262 16.305 16.305 0 01-11.511 4.743H32.386a16.29 16.29 0 01-11.501-4.749 16.184 16.184 0 01-4.764-11.463v-74.31c0-2.129.42-4.238 1.237-6.205a16.21 16.21 0 013.526-5.261 16.272 16.272 0 015.277-3.516A16.314 16.314 0 0132.386 0H156.2a16.317 16.317 0 016.23 1.232 16.277 16.277 0 015.282 3.514 16.207 16.207 0 014.769 11.471z'
          fill='#00D563'
        />
        <path
          d='M172.48 16.217V86.63H16.138V16.217c0-2.129.42-4.238 1.238-6.205A16.21 16.21 0 0120.9 4.751a16.272 16.272 0 015.277-3.516A16.314 16.314 0 0132.404 0H156.2a16.315 16.315 0 016.229 1.232 16.277 16.277 0 015.282 3.514 16.176 16.176 0 014.769 11.471z'
          fill='url(#paint1_linear_118_1957)'
        />
        <path
          d='M145.483 14.692H35.015v21.714h110.468V14.692z'
          fill='url(#paint2_linear_118_1957)'
        />
        <path
          d='M85.194 39.178h-50.18V82.91h50.18V39.178z'
          fill='url(#paint3_linear_118_1957)'
        />
        <path
          d='M144.592 39.178H88.738v14.605h55.854V39.178z'
          fill='url(#paint4_linear_118_1957)'
        />
        <path
          d='M144.592 56.554H88.738V71.16h55.854V56.554z'
          fill='url(#paint5_linear_118_1957)'
        />
        <path
          d='M144.592 73.93H88.738v8.98h55.854v-8.98z'
          fill='url(#paint6_linear_118_1957)'
        />
        <path
          d='M120.558 135.195h2.384l-7.336-92.116-2.015.54.457 6.018-7.239.456-.557-7.014-2.014.54 6.969 91.576h2.384l-.831-10.45 6.989-.428-.104-1.649-7.017.43-.597-7.464 7.174-.453-.102-1.65-7.202.443-.594-7.476 7.035-.446 2.216 29.143zm-13.617-83.46l7.239-.46.569 7.479-7.206.455-.602-7.474zm.727 9.121l7.201-.46.569 7.511-7.166.448-.604-7.499zm.731 9.139l7.164-.458.609 7.984-7.151.433-.622-7.959zm.764 9.604l7.134-.425.529 6.966-7.106.45-.557-6.991zm.686 8.639l7.102-.45.569 7.488-7.074.446-.597-7.484zm1.326 16.613l-.599-7.49 7.072-.45.569 7.494-7.042.446zM59.865 48.928v-5.85h-1.47v5.85h-7.152v1.812h7.151v80.984h1.47V60.17l8.718-9.43h6.675v-1.822l-15.392.01zm0 8.681v-6.87h6.63l-6.63 6.87zM132.485 48.928v-5.85h-1.47v5.85h-14.126v1.812h6.133l7.988 8.633v72.351h1.475V50.74h8.422v-1.822l-8.422.01zm-1.47 7.93l-5.909-6.118h5.904l.005 6.118z'
          fill='#00D563'
        />
        <g opacity={0.61}>
          <path
            d='M120.558 135.195h2.384l-7.336-92.116-2.015.54.457 6.018-7.239.456-.557-7.014-2.014.54 6.969 91.576h2.384l-.831-10.45 6.989-.428-.104-1.649-7.017.43-.597-7.464 7.174-.453-.102-1.65-7.202.443-.594-7.476 7.035-.446 2.216 29.143zm-13.617-83.46l7.239-.46.569 7.479-7.206.455-.602-7.474zm.727 9.121l7.201-.46.569 7.511-7.166.448-.604-7.499zm.731 9.139l7.164-.458.609 7.984-7.151.433-.622-7.959zm.764 9.604l7.134-.425.529 6.966-7.106.45-.557-6.991zm.686 8.639l7.102-.45.569 7.488-7.074.446-.597-7.484zm1.326 16.613l-.599-7.49 7.072-.45.569 7.494-7.042.446z'
            fill='url(#paint7_linear_118_1957)'
          />
          <path
            d='M59.865 48.928v-5.85h-1.47v5.85h-7.152v1.812h7.151v80.984h1.47V60.17l8.718-9.43h6.675v-1.822l-15.392.01zm0 8.681v-6.87h6.63l-6.63 6.87z'
            fill='url(#paint8_linear_118_1957)'
          />
          <path
            d='M132.485 48.928v-5.85h-1.47v5.85h-14.126v1.812h6.133l7.988 8.633v72.351h1.475V50.74h8.422v-1.822l-8.422.01zm-1.47 7.93l-5.909-6.118h5.904l.005 6.118z'
            fill='url(#paint9_linear_118_1957)'
          />
        </g>
        <path
          d='M117.108 67.57l-.169 1.517h-3.518s-.287-.876.355-1.095a5.99 5.99 0 011.083-.271l2.249-.152z'
          fill='#00D563'
        />
        <path
          d='M112.203 36.135a11.367 11.367 0 00.25 4.063 1.798 1.798 0 001.69.674v1.01h1.692l.709-5.056s-2.648-3.371-4.341-.691z'
          fill='url(#paint10_linear_118_1957)'
        />
        <path
          d='M113.389 36.64c.265.528.434 1.1.499 1.687 0 0 .337-.675.5-.339.162.336-.337 1.013-.337 1.013l.499.84h1.71s.846-3.689.372-4.197c-.475-.507-.794-.497-.794-.497s0-.498-1.016-.498-2.367 0-2.873.844c-.507.843-.677.497-.677.497s.287.625.727.473c.104-.025 1.22-.328 1.39.177z'
          fill='#333'
        />
        <path
          d='M114.148 41.882h2.843s1.201.249 1.368 3.118c.102 1.96.102 3.924 0 5.884v4.703l-1.368-.456-5.075 1.13-.499-6.895a3.66 3.66 0 01-2.611-1.612 4.167 4.167 0 01-.439-3.792l3.532 1.854.187-.995a4.228 4.228 0 011.69-2.683l.372-.256z'
          fill='#00D563'
        />
        <path
          d='M108.838 43.03l-.843-2.698 3.365-.508 1.133 3.675-.627 2.21-2.012-1.013-1.016-1.667z'
          fill='#FCFDFF'
        />
        <path
          d='M108.162 44.544a2.648 2.648 0 01.676-1.515l.17.167h1.066l.17.66-.39.554a1.467 1.467 0 01-1.692.134z'
          fill='url(#paint11_linear_118_1957)'
        />
        <path
          d='M109.854 44.696l.829 2.192 1.183-1.18-2.012-1.012z'
          fill='url(#paint12_linear_118_1957)'
        />
        <path
          opacity={0.61}
          d='M111.36 49.247s2.706-1.013 2.706-2.697l.679 7.74-2.879.68-.506-5.723z'
          fill='url(#paint13_linear_118_1957)'
        />
        <path
          d='M111.866 54.962l-.506 8.395.676 4.381h2.03l.337-7.23 1.183-3.035-.844 10.265 2.366.17 1.166-13.62-1.335-.505-5.073 1.18z'
          fill='#333'
        />
        <path
          d='M113.963 67.738v1.687l-3.567-1.269s0-.928.691-.928c.375-.002.749.032 1.116.102l1.76.408zM67.408 134.32l.175 1.512h3.52s.287-.875-.357-1.094a5.671 5.671 0 00-1.081-.269l-2.257-.149z'
          fill='#00D563'
        />
        <path
          d='M69.842 102.562a11.414 11.414 0 011.15 3.878c-.201.961-1.387 1.18-1.387 1.18l.322.96-1.69.59-2.301-4.551s1.437-4.063 3.906-2.057z'
          fill='url(#paint14_linear_118_1957)'
        />
        <path
          d='M68.879 103.422a4.895 4.895 0 000 1.685s-.542-.523-.592-.152c-.05.371.641.843.641.843l-.202.961-1.537.522s-1.997-3.234-1.693-3.859c.305-.624.457-.691.457-.691s-.17-.473.794-.809c.963-.336 2.246-.746 2.995-.117.75.63.794.249.794.249s0 .674-.542.692c.053.069-1.115.136-1.115.676z'
          fill='#333'
        />
        <path
          d='M70.451 108.598h-2.84s-1.201.248-1.37 3.117a56.35 56.35 0 000 5.882v4.703l1.37-.456 5.072 1.13.5-6.892a3.687 3.687 0 002.554-1.719 4.208 4.208 0 00.438-3.795l-3.535 1.854-.187-.995a4.229 4.229 0 00-1.69-2.68l-.312-.149z'
          fill='#00D563'
        />
        <path
          d='M75.678 109.76l.844-2.68-3.382-.505-1.116 3.675.609 2.207 2.03-1.01 1.015-1.687z'
          fill='#FCFDFF'
        />
        <path
          d='M76.352 111.295a2.625 2.625 0 00-.676-1.518l-.167.169h-1.066l-.17.657.39.555a1.468 1.468 0 001.69.137z'
          fill='url(#paint15_linear_118_1957)'
        />
        <path
          opacity={0.61}
          d='M73.14 116.047s-2.706-1.01-2.706-2.697l.22 9.136 1.979.438.507-6.877z'
          fill='url(#paint16_linear_118_1957)'
        />
        <path
          d='M72.633 121.71l.507 8.395-.66 4.381h-2.029l-.337-7.23-1.186-3.036.847 10.266-2.367.169-1.183-13.619 1.35-.505 5.058 1.179z'
          fill='#333'
        />
        <path
          d='M70.554 134.486v1.182l3.702-.169s-.168-1.18-.844-1.18a2.065 2.065 0 01-1.049-.236l-1.81.403z'
          fill='#00D563'
        />
        <path
          d='M130.366 36.309h-8.642a4.458 4.458 0 01-3.144-1.3 4.425 4.425 0 01-1.302-3.134v-1.889c0-1.175.468-2.302 1.302-3.133a4.454 4.454 0 013.144-1.298h8.642a4.457 4.457 0 013.145 1.297 4.421 4.421 0 011.303 3.134v1.889a4.431 4.431 0 01-2.746 4.096 4.462 4.462 0 01-1.702.338z'
          fill='#fff'
        />
        <path
          d='M118.274 38.645s3.535.17 4.381-2.359h2.621s-1.757 3.203-7.002 2.36z'
          fill='#fff'
        />
        <path
          opacity={0.15}
          d='M120.271 27.217h11.872a.303.303 0 01.305.303v.237a.303.303 0 01-.305.304h-11.872a.303.303 0 01-.304-.304v-.236a.303.303 0 01.304-.304zM120.271 29.24h11.872a.303.303 0 01.305.304v.236a.303.303 0 01-.305.303h-11.872a.303.303 0 01-.304-.303v-.236a.303.303 0 01.304-.304zM120.271 31.245h11.872a.303.303 0 01.305.303v.237a.303.303 0 01-.305.304h-11.872a.304.304 0 01-.304-.304v-.236a.303.303 0 01.304-.304zM120.271 33.268h6.473a.305.305 0 01.302.304v.249a.305.305 0 01-.302.303h-6.473a.304.304 0 01-.304-.303v-.25a.303.303 0 01.304-.303z'
          fill='#020202'
        />
        <path
          d='M51.58 103.539h8.642a4.448 4.448 0 003.104-1.274 4.422 4.422 0 001.324-3.075v-1.97a4.424 4.424 0 00-1.302-3.134 4.454 4.454 0 00-3.144-1.298H51.58c-1.18 0-2.312.468-3.146 1.299a4.426 4.426 0 00-1.303 3.135v1.97a4.43 4.43 0 001.334 3.08 4.455 4.455 0 003.115 1.267zM63.637 105.933s-3.535.169-4.381-2.359h-2.604s1.695 3.168 6.985 2.359z'
          fill='#fff'
        />
        <path
          opacity={0.15}
          d='M61.642 95.299H49.77a.305.305 0 01-.305-.304v-.236a.303.303 0 01.305-.304h11.872a.305.305 0 01.304.304v.236a.303.303 0 01-.304.304zM61.642 97.337H49.77a.307.307 0 01-.282-.188.303.303 0 01-.023-.116v-.236a.304.304 0 01.305-.301h11.872a.305.305 0 01.304.3v.237a.303.303 0 01-.304.304zM61.642 99.342H49.77a.305.305 0 01-.305-.301v-.236a.303.303 0 01.305-.304h11.872a.305.305 0 01.304.303v.237a.302.302 0 01-.304.301zM61.642 101.365h-6.478a.305.305 0 01-.304-.304v-.234a.302.302 0 01.304-.303h6.478a.305.305 0 01.305.303v.234a.303.303 0 01-.305.304z'
          fill='#020202'
        />
        <path
          opacity={0.61}
          d='M74.595 111.613s-.5 2.192-1.183 1.856a1.681 1.681 0 01-.846-1.012l2.03-.844z'
          fill='url(#paint17_linear_118_1957)'
        />
      </g>
      <defs>
        <linearGradient
          id='paint0_linear_118_1957'
          x1={95.3863}
          y1={102.106}
          x2={95.3863}
          y2={140.293}
          gradientUnits='userSpaceOnUse'
        >
          <stop stopOpacity={0.4} />
          <stop offset={1} stopColor='#fff' stopOpacity={0} />
        </linearGradient>
        <linearGradient
          id='paint1_linear_118_1957'
          x1={42.5908}
          y1={-9.80557}
          x2={169.023}
          y2={133.289}
          gradientUnits='userSpaceOnUse'
        >
          <stop offset={0.02} stopColor='#fff' stopOpacity={0} />
          <stop offset={1} stopColor='#fff' />
        </linearGradient>
        <linearGradient
          id='paint2_linear_118_1957'
          x1={87.2109}
          y1={157.232}
          x2={91.6972}
          y2={-38.5661}
          gradientUnits='userSpaceOnUse'
        >
          <stop offset={0.02} stopColor='#fff' stopOpacity={0} />
          <stop offset={1} stopColor='#fff' />
        </linearGradient>
        <linearGradient
          id='paint3_linear_118_1957'
          x1={57.4034}
          y1={178.17}
          x2={61.8897}
          y2={-17.6288}
          gradientUnits='userSpaceOnUse'
        >
          <stop offset={0.02} stopColor='#fff' stopOpacity={0} />
          <stop offset={1} stopColor='#fff' />
        </linearGradient>
        <linearGradient
          id='paint4_linear_118_1957'
          x1={113.731}
          y1={173.731}
          x2={118.217}
          y2={-22.0675}
          gradientUnits='userSpaceOnUse'
        >
          <stop offset={0.02} stopColor='#fff' stopOpacity={0} />
          <stop offset={1} stopColor='#fff' />
        </linearGradient>
        <linearGradient
          id='paint5_linear_118_1957'
          x1={113.636}
          y1={195.25}
          x2={118.122}
          y2={-0.548158}
          gradientUnits='userSpaceOnUse'
        >
          <stop offset={0.02} stopColor='#fff' stopOpacity={0} />
          <stop offset={1} stopColor='#fff' />
        </linearGradient>
        <linearGradient
          id='paint6_linear_118_1957'
          x1={115.101}
          y1={146.247}
          x2={119.588}
          y2={-49.5486}
          gradientUnits='userSpaceOnUse'
        >
          <stop offset={0.02} stopColor='#fff' stopOpacity={0} />
          <stop offset={1} stopColor='#fff' />
        </linearGradient>
        <linearGradient
          id='paint7_linear_118_1957'
          x1={133.736}
          y1={143.52}
          x2={83.1143}
          y2={7.21925}
          gradientUnits='userSpaceOnUse'
        >
          <stop offset={0.58} />
          <stop offset={0.78} stopOpacity={0.16} />
        </linearGradient>
        <linearGradient
          id='paint8_linear_118_1957'
          x1={92.4431}
          y1={158.857}
          x2={41.8215}
          y2={22.5533}
          gradientUnits='userSpaceOnUse'
        >
          <stop offset={0.58} />
          <stop offset={0.78} stopOpacity={0.16} />
        </linearGradient>
        <linearGradient
          id='paint9_linear_118_1957'
          x1={153.146}
          y1={136.313}
          x2={102.525}
          y2={0.00877315}
          gradientUnits='userSpaceOnUse'
        >
          <stop offset={0.58} />
          <stop offset={0.78} stopOpacity={0.16} />
        </linearGradient>
        <linearGradient
          id='paint10_linear_118_1957'
          x1={112.126}
          y1={38.4908}
          x2={116.549}
          y2={38.4908}
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#ECC4D7' />
          <stop offset={0.42} stopColor='#EFD4D1' />
          <stop offset={1} stopColor='#F2EAC9' />
        </linearGradient>
        <linearGradient
          id='paint11_linear_118_1957'
          x1={108.162}
          y1={43.8899}
          x2={110.244}
          y2={43.8899}
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#ECC4D7' />
          <stop offset={0.42} stopColor='#EFD4D1' />
          <stop offset={1} stopColor='#F2EAC9' />
        </linearGradient>
        <linearGradient
          id='paint12_linear_118_1957'
          x1={109.2}
          y1={45.3852}
          x2={113.336}
          y2={46.9717}
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#68E1FD' />
          <stop offset={0.01} stopColor='#67DDF9' />
          <stop offset={0.12} stopColor='#5CB3CE' />
          <stop offset={0.24} stopColor='#538EA9' />
          <stop offset={0.37} stopColor='#4C718B' />
          <stop offset={0.5} stopColor='#465A73' />
          <stop offset={0.63} stopColor='#424A63' />
          <stop offset={0.79} stopColor='#404059' />
          <stop offset={0.99} stopColor='#3F3D56' />
        </linearGradient>
        <linearGradient
          id='paint13_linear_118_1957'
          x1={105.057}
          y1={51.1948}
          x2={117.927}
          y2={50.4761}
          gradientUnits='userSpaceOnUse'
        >
          <stop offset={0.36} stopColor='#00272E' />
          <stop offset={1} stopColor='#69B9EB' stopOpacity={0} />
        </linearGradient>
        <linearGradient
          id='paint14_linear_118_1957'
          x1={65.9355}
          y1={105.587}
          x2={70.9929}
          y2={105.587}
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#ECC4D7' />
          <stop offset={0.42} stopColor='#EFD4D1' />
          <stop offset={1} stopColor='#F2EAC9' />
        </linearGradient>
        <linearGradient
          id='paint15_linear_118_1957'
          x1={74.2729}
          y1={110.638}
          x2={76.3523}
          y2={110.638}
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#ECC4D7' />
          <stop offset={0.42} stopColor='#EFD4D1' />
          <stop offset={1} stopColor='#F2EAC9' />
        </linearGradient>
        <linearGradient
          id='paint16_linear_118_1957'
          x1={76.9939}
          y1={118.816}
          x2={68.263}
          y2={117.722}
          gradientUnits='userSpaceOnUse'
        >
          <stop offset={0.36} stopColor='#00272E' />
          <stop offset={1} stopColor='#69B9EB' stopOpacity={0} />
        </linearGradient>
        <linearGradient
          id='paint17_linear_118_1957'
          x1={72.5657}
          y1={112.559}
          x2={74.5951}
          y2={112.559}
          gradientUnits='userSpaceOnUse'
        >
          <stop offset={0.36} stopColor='#00272E' />
          <stop offset={1} stopColor='#69B9EB' stopOpacity={0} />
        </linearGradient>
        <clipPath id='clip0_118_1957'>
          <path fill='#fff' d='M0 0H205.625V141H0z' />
        </clipPath>
      </defs>
    </svg>
  );
}

export default SvgComponent;
